import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Footer from './footer';
import Navbars from './Navbar';
import Carousels from './carousel';
 
const CsbDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
 
  const { csbName, hawbNo, courierName } = location.state || {};
 
  const [csbDetails, setCsbDetails] = useState(null);
  const [error, setError] = useState(null);
  const [selectedCsbName, setSelectedCsbName] = useState(csbName);
 
  const displayFields = [
    { fieldKey: 'csbNo', label: 'CSB No' },
    { fieldKey: 'csbDate', label: 'CSB Date' },
    { fieldKey: 'assessableValue', label: 'Assessable Value' },
    { fieldKey: 'totalDuty', label: 'Total Duty' },
    { fieldKey: 'status', label: 'Status' },
    { fieldKey: 'detail_description', label: 'Detail Description' },
    { fieldKey: 'modified_date', label: 'Modified Date' },
    { fieldKey: 'hawbNo', label: 'HAWB No' },
    { fieldKey: 'courierName', label: 'Courier Co' },
  ];
 
  useEffect(() => {
    if (!csbName || !hawbNo || !courierName) return;
 
    const fetchCsbDetails = async () => {
      try {
        const response = await fetch(`/eicimobility/csbDetails`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ csbName, hawbNo, courierName }),
        });
 
        const data = await response.json();
 
        if (response.ok) {
          setCsbDetails(data);
        } else {
          setError(data.errorMessage || 'Failed to fetch CSB details.');
        }
      } catch (err) {
        setError('Error fetching data.');
      }
    };
 
    fetchCsbDetails();
  }, [csbName, hawbNo, courierName]);
 
  if (!csbName || !hawbNo || !courierName) {
    return (
<div className="alert alert-danger text-center mt-5">
        Missing CSB details. Please search again.
</div>
    );
  }
 
  const renderCsbList = () => {
    if (!csbDetails || !csbDetails.csbNoList) return null;
 
    const csbNameList = csbDetails.csbNoList;
 
    if (csbNameList.length === 0) {
      return <div className="alert alert-info text-center">No CSB Numbers available</div>;
    }
 
    return (
<ul className="list-group">
        {csbNameList.map((csb, idx) => (
<li
            key={idx}
            className={`list-group-item ${csb === selectedCsbName ? 'active' : ''}`}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setSelectedCsbName(csb);
              navigate('/csbDetails', {
                state: { csbName: csb, hawbNo, courierName },
              });
            }}
>
            {csb}
</li>
        ))}
</ul>
    );
  };
 
  const renderCsbData = () => {
    if (error) {
      return <div className="alert alert-danger text-center">{error}</div>;
    }
 
    if (!csbDetails) {
      return <div className="text-center">Loading...</div>;
    }
 
    const { exportDetails } = csbDetails;
 
    return (
<table className="table table-bordered table-striped table-sm mt-4">
<tbody>
          {displayFields.map(({ fieldKey, label }) => {
            const fieldValue = exportDetails?.[fieldKey];
            return fieldValue !== undefined && fieldValue !== null ? (
<tr key={fieldKey}>
<td>{label}</td>
<td>{typeof fieldValue === 'object' ? JSON.stringify(fieldValue) : fieldValue}</td>
</tr>
            ) : null;
          })}
          {csbDetails.hawbNo && (
<tr key="hawbNo">
<td>HAWB No</td>
<td>{csbDetails.hawbNo}</td>
</tr>
          )}
          {csbDetails.courierName && (
<tr key="courierName">
<td>Courier Co</td>
<td>{csbDetails.courierName}</td>
</tr>
          )}
</tbody>
</table>
    );
  };
 
  return (
<div className="container-fixed">
<Navbars />
<Carousels />
<Container className="mt-4 import-form-carousel">
<h3 className="text-center mb-4">Export</h3>
        {renderCsbList()}
        {renderCsbData()}
<br />
<button
          type="button"
          className="btn btn-danger submit-btn return-btn"
          onClick={() => navigate('/export')}
>
          RETURN
</button>
</Container>
<Footer />
</div>
  );
};
 
export default CsbDetails;